<template>
  <!-- 新建工单 -->
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="creatWorkOrder"
        style=""
        icon="el-icon-circle-plus"
        >提交工单</el-button
      >
    </div>
    <div class="form-wrap">
      <el-card>
        <work-order-header-info
          @selectPeiBuFinish="selectPeiBuFinish_Func"
          ref="orderHeaderInfo"
          :machineList="machineList"
          style="margin-top:5px"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import { workOrderHeaderInfo } from "./components";
export default {
  components: {
    workOrderHeaderInfo,
  },
  data() {
    return {
      machineList: [],
      workOrderInfo: {}, // 给编辑工单 临时缓存用。
    };
  },
  methods: {
    // 创建工单
    creatWorkOrder() {
      // 判定  工单头部  与  工艺单  是否都填好了
      if (!this.$refs.orderHeaderInfo.getValid()) {
        return;
      }

      const workOrderHeader = this.$refs.orderHeaderInfo.getWorkOrderHeader();
      // const craftOrder = this.$refs.craftInfo.getCraftOrder();
      // console.log(craftOrder);
      console.log(workOrderHeader);
      const workOrder = {
        checkTime: 0,
        closeTime: 0,
        clothLength: workOrderHeader.clothLength,
        combs: "",
        combsCount: 0,
        consignTime: 0,
        craftOrganization: "",
        craftsheetId: 0,
        createTime: workOrderHeader.createTime,
        creator: workOrderHeader.creator,
        creatorId: 0,
        customer: workOrderHeader.customer,
        dcount: workOrderHeader.dcount,
        density: "",
        departId: 0,
        dropClothLength: 0,
        factoryId: 0,
        finishedGbCount: workOrderHeader.finishedGbCount,
        gbCount: workOrderHeader.gbCount,
        gbPerimeter: workOrderHeader.gbPerimeter,
        gbSize: workOrderHeader.gbSize * 100,
        headLine: workOrderHeader.headLine,
        id: 0,
        lastBatchNumber: "",
        machineId: workOrderHeader.machineId,
        machineType: "",
        materialId: workOrderHeader.materialId,
        materialNumber: workOrderHeader.materialNumber,
        meshCount: 0,
        meterWeight: "",
        nowProducedLength: 0,
        nowWeight: 0,
        // number: workOrderHeader.number,
        orderKind: 0,
        predictProducedLength: 0,
        predictWeight: 0,
        productFinishTime: 0,
        productName: workOrderHeader.productName,
        productStartTime: 0,
        remark: workOrderHeader.remark,
        silkNumber: "",
        speed: workOrderHeader.speed * 100,
        squareGrams: "",
        status: 0,
        temperature: workOrderHeader.temperature,
        threadCount: "",
        turns: workOrderHeader.turns,
        unit: "",
        updateTime: 0,
        workStatus: 0,
      };

      // const workOrder = {
      //   changed: true, // 不知道是啥，暂定true.
      //   combs: workOrderHeader.combs, // 幅宽
      //   combsCount: Number(workOrderHeader.combsCount), // 幅数
      //   consignTime: 0, // 交付时间
      //   craftOrganization: "", // 工艺组织

      //   craftsheet: {
      //     // 梳节信息
      //     craftItems: craftOrder.craftItems, // 梳节记录--直接复制
      //     craftRemarks: "",
      //     // createTime: 0,  不用填
      //     // id: 0,  不用填

      //     //注意，这里是'胚布'的，craftItems 里头 是原料的。
      //     materialId: workOrderHeader.materialId, //物料id
      //     // name: workOrderHeader.craftsheet.name, // 胚布名称?
      //     name: workOrderHeader.name_change, // 胚布名称. 必填项，不能多级存储。
      //     // number: workOrderHeader.craftsheet.number, // 胚布编号?
      //     number: workOrderHeader.number_change, // 胚布编号. 必填项，不能多级存储。

      //     optlock: 0,
      //     updateTime: 0,
      //   },

      //   craftsheetId: 0, // 工艺单ID
      //   createTime: workOrderHeader.createTime, // 创建时间/制单日期 220405 liuqy: 不可编辑，提交时自动生成。
      //   customer: "", // 客户
      //   density: this.hmjDataChange(workOrderHeader.density), // 密度，针密？
      //   departId: 0, // 部门ID
      //   dropClothLength: Number(workOrderHeader.dropClothLength) * 100, // 匹长. 前端是'米'，后台是'厘米'，提交时*100，显示时/100。
      //   // fabricName: '', // 胚布名称--将来用，先放到 craftsheet里头。
      //   // fabricNumber: '', // 胚布编号--将来用，先放到 craftsheet里头。
      //   factoryId: 0,
      //   // "id": 0,  不用填
      //   lastBatchNumber: "",
      //   machineId: workOrderHeader.machineId,
      //   meshCount: Number(workOrderHeader.meshCount), // 目数
      //   meterWeight: this.hmjDataChange(workOrderHeader.meterWeight),
      //   predictWeight: this.hmjDataChange(workOrderHeader.predictWeight*1000), // 测量米重=理论重量
      //   nowProducedLength: 0, // 已完成(米)--220405 liuqy 不可编辑，系统内部自动结算
      //   // number: workOrderHeader.number, // 生产编号=>工单编号--后台自动生成
      //   nowWeight: 0,
      //   parentId: 0,
      //   // 目标产量输入时是米，要转换成厘米，后台是按整数(厘米)存储。
      //   predictProducedLength: Number(
      //     this.hmjDataChange(workOrderHeader.predictProducedLength*100)
      //   ), // 目标产量
      //   productFinishTime: 0,
      //   productInProgress: false, // false=未生产, true=生产中。
      //   productName: "",
      //   productStartTime: 0,
      //   remark: workOrderHeader.remark, // 备注
      //   silkNumber: workOrderHeader.silkNumber, // 组织纱丝号
      //   speed: this.hmjDataChange(workOrderHeader.speed), // 车速?
      //   squareGrams: this.hmjDataChange(workOrderHeader.squareGrams), // 平方克, 计算克数?
      //   status: 0, // 状态:  0 = 未审核(新建固定)，1=审核。
      //   threadCount: this.hmjDataChange(workOrderHeader.threadCount), // 针数
      //   unit: "", // 单位
      //   // "updateTime": 0  不用填
      //   // workStatus: workOrderHeader.workStatus // 上机状态. 220405 liuqy: 提交工单前，不显示"上机状态"。
      // };

      switch (this.$route.query.type) {
        case 1: // 编辑
          // 工单编辑时候，要注意把id 强制追加进去。
          workOrder.id = this.workOrderInfo.id;
          workOrder.craftsheet.id = this.workOrderInfo.craftsheet.id;
          console.log(this.workOrderInfo);
          //更新请求
          this.$requestBase(
            {
              url: "v1/factory/product-order/warper-order/update",
              method: "POST",
              data: workOrder,
            },
            true
          ).then((res) => {
            this.$Message.success(res.info);
            this.$router.push("/product/beamWarping");
          });
          break;

        case 0: // 新建
        case 2: // 复制
        default:
          this.$requestBase(
            {
              url: "v1/factory/product-order/warper-order/create",
              method: "POST",
              data: workOrder,
            },
            true
          ).then((res) => {
            this.$Message.success(res.info);
            this.$router.push("/product/beamWarping");
          });
          break;
      }
    },

    // 获取机台列表
    getMachineList() {
      this.$requestBase({
        url: "factory/machine/selectList",
        method: "get",
        params: {
          kind: 1,
        },
      }).then((res) => {
        // console.log(res)
        this.machineList = res.data;
      });
    },
    // 根据ID，获取工单信息
    getworkOrderInfo(type, workOrderId) {
      this.$requestBase({
        url: "v1/factory/product-order/work-order/detail",
        method: "get",
        params: {
          id: workOrderId,
        },
      }).then((res) => {
        res = res.data;

        this.workOrderInfo = res;
        console.log(this.workOrderInfo);
        this.$refs.orderHeaderInfo.setworkOrderHeader(res, type);
        // this.$refs.craftInfo.setCraftOrder(res.craftsheet);
      });
    },

    // 字符串 '2.34512345' 四舍五入成 2位小数=2.35, 再转换成 字符串 '2.35'。注意禁止使用toFixed()。
    // https://wenku.baidu.com/view/a20d74dcadf8941ea76e58fafab069dc50224761.html
    hmjDataChange(inputStr) {
      let data1 = Number(inputStr); // 先转数字
      //Math.round()方法用来把一个数字舍入为最接近的整数
      let data2 = Math.round(data1 * 100) / 100;
      return data2.toString(); //转字符串
    },

    //选择胚布后的对应处理
    selectPeiBuFinish_Func(date) {
      this.$requestBase({
        url: "v1/material/detail",
        method: "get",
        params: {
          id: date.materialId,
        },
      }).then((res) => {
        res = res.data;
        // console.log('res=', res)
        //自动更新 疏节 列表的信息。
        // this.$refs.craftInfo.updateCraftOrder(res);
      });
    },
  },
  created() {},
  // mounted:html加载完成后执行。执行顺序：子组件-父组件
  mounted() {
    this.getMachineList();

    switch (this.$route.query.type) {
      case 1: // 编辑
      case 2: // 复制
        this.getworkOrderInfo(
          this.$route.query.type,
          this.$route.query.workOrderId
        );
        break;
      case 0: // 新建
      default:
        break;
    }
  },
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.el-input {
  margin: 6px 10px 0px 0px;
  width: 220px;
}

.el-tabs {
  margin: 8px;
}

.footer {
  float: right;
  margin: 0px 10px 10px 0px;
}
</style>
